import { format } from "date-fns";
import { useRef, useState } from "react";
import { useCustomArtStore, type CustomArt } from "../../stores/custom-art-store";
import { useScheduleStore } from "../../stores/schedule-store";

type ExportFile = (
  data: ReturnType<typeof useScheduleStore.getState>,
  filename: string,
  layers: CustomArt[],
) => Promise<void>;

export function useScheduleExport(
  extension: "pptx" | "psd",
  exportFile: ExportFile,
  onOpenChange: (open: boolean) => void,
) {
  const busy = useRef(false);
  const [exporting, setExporting] = useState(false);
  const [failed, setFailed] = useState(false);

  const changeOpen = (open: boolean) => {
    if (busy.current) return;
    setFailed(false);
    onOpenChange(open);
  };

  const exportSchedule = async () => {
    if (busy.current) return;
    busy.current = true;
    setExporting(true);
    setFailed(false);

    try {
      const data = useScheduleStore.getState();
      const layers = useCustomArtStore.getState().layers;
      const date = format(data.week[0]!, "yyyy-MM-dd");
      const filename = `schedule-${date}.${extension}`;
      await exportFile(data, filename, layers);
      onOpenChange(false);
    } catch {
      setFailed(true);
    } finally {
      busy.current = false;
      setExporting(false);
    }
  };

  return { exporting, failed, changeOpen, exportSchedule };
}
